import type * as Shared from "../../../_shared";
import type * as Repository from "../../repository";

type Props = {
	queryData: Repository.Query.Type.QueryData;
};
type InputModel = Shared.Model.Type.FormModel["InputModel"];

export const serverModelToInputModelConverter = ({ queryData }: Props): InputModel => {
	const { voucher } = queryData;

	const inputModel: InputModel = {
		hotelID: voucher.hotelID,
		voucherID: voucher.voucherID,

		inSale: voucher.inSale,

		name: voucher.name,
		description: voucher.description,

		mainKeyVisual: voucher.mainKeyVisual,

		voucherPrice: voucher.voucherPrice,
		sellingPrice: voucher.sellingPrice,

		saleTypeForTerm: voucher.saleTypeForTerm,
		saleStart: voucher.saleStart || undefined,
		saleEnd: voucher.saleEnd || undefined,

		voucherLimitType: voucher.voucherLimitType,

		cinStart: voucher.cinStart || undefined,
		cinEnd: voucher.cinEnd || undefined,

		intervalPrepDates: voucher.intervalPrepDates,
		soldNumTotal: voucher.soldNumTotal,

		maxStockNum: voucher.maxStockNum,
	} satisfies InputModel;

	return inputModel;
};
